import Api from "./Api";

export default class extends Api {
  constructor() {
    super("/spotlight");
  }
}
